module.exports = __webpack_public_path__ + "img/平均得分.e1799fea.png";